import { Modal } from 'antd-mobile'
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { TIMER_SUCCESS } from '../actions/actionTypes'
import { setLoading, setLoadingInit } from '../actions/appActions'
import { actionTypes } from '../actions/restaurantActions'
import { actionTypes as orderActionTypes } from '../actions/orderActions'
import { ACCESS_SERVICES_MAP, APP_SERVICE, StorageKeys } from '../constants'
import apiConfig from '../constants/apiConfig'
import i18n from '../locales/i18n'
import paths from '../routes/paths'
import { getRestaurantId, getRestaurantPath } from '../selectors'
import { sendRequest } from '../services/apiService'
import {
    checkInvalidRestaurant,
    runAppTimer
} from '../utils'
import { ensureObject } from '../utils/helper'
import { getObjectData, removeStoreData, setObjectData } from '../utils/localStorageHelper'
import { getRestaurantInfo } from './selectors'
const alert = Modal.alert

const clearDataLocal = () => {
    setObjectData(StorageKeys.cartDetails, null)
    setObjectData(StorageKeys.restaurantData, null)
    setObjectData(StorageKeys.foodGroup, null)
}

function* _getRestaurantInfo({ payload: { params, onDone } }) {
    yield put(setLoadingInit(true))
    const restaurantPath = yield select(getRestaurantPath);
    try {
        const { success, responseData } = yield call(
            sendRequest,
            {
                ...apiConfig.restaurant.getInfo,
                path: `${apiConfig.restaurant.getInfo.path}/${restaurantPath}`,
            },
            {}
        )

        if (success && responseData.result) {
            const { data } = responseData
            /* check out of extend date */
            if (checkInvalidRestaurant(data.serverTime, data.extendDate)) {
                // yield put({ type: REFRESH_DATA })
                alert('', i18n.t('message.messageInvalidTable'), [])
                return
            }

            const settings = ensureObject(JSON.parse(data.settings))
            try {
                settings.happy_hours_settings =
                    settings.happy_hours_settings.reduce(
                        (rs, current) => ({
                            ...rs,
                            [current.timeframe]: current,
                        }),
                        {}
                    )
            } catch (error) {
                settings.happy_hours_settings = {}
            }

            const payload = {
                ...data,
                isReady: APP_SERVICE === ACCESS_SERVICES_MAP.WEB ? data.isReady : true,
                settings,
                services: (data.services || '').split(';'),
            }

            // kiểm tra ngoài giờ mở cửa
            runAppTimer(settings.timezone?.offset, payload.serverTime)

            setObjectData(StorageKeys.appLanguage, payload.lang)
            i18n.changeLanguage(payload.lang, () => {})
            const oldSetting = getObjectData(StorageKeys.restaurantData)
            if (oldSetting?.stopServices !== payload?.stopServices) {
                yield put({
                               type: orderActionTypes.CLEAR_ALL_ORDER_DATA
                           })
                removeStoreData(StorageKeys.order)
            }
            yield put({
                type: actionTypes.SET_RESTAURANT_INFO,
                payload,
            })
        } else {
            throw i18n.t('message.invalidRestaurant')
            // window.location.replace(paths.notFound)
        }

        typeof onDone === 'function' && onDone({ success, responseData })
    } catch (error) {
        console.log(error)
        Modal.defaultProps.style = {
            display: 'none'
        }
        alert('', i18n.t('message.invalidRestaurant'), [])
    } finally {
        yield put(setLoadingInit(false))
    }
}

function* _requestTable({ payload: { params, onDone } }) {
    const { success, responseData } = yield call(
        sendRequest,
        apiConfig.restaurant.requestTable,
        params
    )
    if (success && responseData.result) {
        yield put({
            type: actionTypes.REQUEST_TABLE_SUCCESS,
            payload: {
                ...responseData.data,
            },
        })
    }
    if (typeof onDone === 'function') {
        onDone({ success, responseData })
    }
}

function* _retryRequestTable({ payload: { params, onDone } }) {
    const { accountId, hash, tableOrdersId } = yield select(getRestaurantInfo);
    const restaurantId = yield select(getRestaurantId);
    const { success, responseData } = yield call(
        sendRequest,
        apiConfig.restaurant.retryRequestTable,
        {
            accountId,
            restaurantId,
            hash,
            tableOrdersId,
        }
    )
    if (typeof onDone === 'function') {
        onDone({ success, responseData })
    }
}

// function* _verifyTable({ payload: { params, onDone } }) {
//     const {
//         accountId,
//         hash,
//         tableNumber,
//         verificationCode: code,
//     } = yield select(getRestaurantInfo);
//     const restaurantId = yield select(getRestaurantId);
//     let { verificationCode, refreshOnFail } = params
//     if (!verificationCode) {
//         verificationCode = code
//     }
//     yield put(setLoading(true))
//     const response = yield call(sendRequest, apiConfig.restaurant.verifyTable, {
//         accountId,
//         restaurantId,
//         hash,
//         tableNumber,
//         verificationCode,
//     })
//     yield put(setLoading(false))
//     const { success, responseData } = response
//     if (success) {
//         if (responseData.result && responseData.data) {
//             const {
//                 customerNumber,
//                 localTime,
//                 serverTime,
//                 tableOrdersId,
//             } = responseData.data
//             runCustomTimer(localTime, serverTime)
//             yield put({ type: TIMER_SUCCESS })
//             yield put({
//                 type: actionTypes.UPDATE_RESTAURANT_INFO,
//                 payload: {
//                     customerNumber,
//                     tableOrdersId,
//                     verificationCode,
//                 },
//             })
//             // run timer
//         } else if (refreshOnFail) {
//             clearDataLocal()
//             window.location.replace(paths.notFound)
//         }
//     }
//     if (typeof onDone === 'function') {
//         onDone(response)
//     }
// }

function* _checkTableStatus({ payload: { params, onDone } }) {
    const { accountId, hash, tableOrdersId } = yield select(getRestaurantInfo);
    const restaurantId = yield select(getRestaurantId);
    let { refreshOnFail, showLoading = true } = params
    if (showLoading) {
        yield put(setLoading(true))
    }
    const response = yield call(
        sendRequest,
        apiConfig.restaurant.checkTableStatus,
        {
            accountId,
            restaurantId,
            hash,
            tableOrdersId,
        }
    )
    if (showLoading) {
        yield put(setLoading(false))
    }
    const { success, responseData } = response
    if (success && responseData.result) {
        const { localTime, serverTime, state } = responseData.data
        yield put({
            type: actionTypes.CHECK_TABLE_STATUS_SUCCESS,
            payload: {
                state,
            },
        })
        // runCustomTimer(localTime, serverTime)
        yield put({ type: TIMER_SUCCESS })
    } else if (refreshOnFail) {
        clearDataLocal()
        window.location.replace(paths.notFound)
    }
    if (typeof onDone === 'function') {
        onDone(response)
    }
}

const sagas = [
    takeLatest(actionTypes.GET_RESTAURANT, _getRestaurantInfo),
    // takeLatest(actionTypes.VERIFY_TABLE, _verifyTable),
    takeLatest(actionTypes.REQUEST_TABLE, _requestTable),
    takeLatest(actionTypes.RETRY_REQUEST_TABLE, _retryRequestTable),
    takeLatest(actionTypes.CHECK_TABLE_STATUS, _checkTableStatus),
]

export default sagas
